import { Box, Grid, Typography, styled } from '@mui/material';
import { useContext } from 'react';
import { TicketContext } from '@/context/TicketContext';
import { useTranslation } from '@/hooks/useTranslation';

const BoxStyled = styled(Box)(() => ({
  padding: '30px',
  transition: '0.1s ease-in',
  cursor: 'pointer',
  color: 'inherit',
  '&:hover': {
    transform: 'scale(1.03)',
  },
}));

const TicketFilter = () => {
  const { meta, setFilter }: any = useContext(TicketContext);
  const { t } = useTranslation();

  return (
    <Grid container spacing={3} textAlign="center">
      <Grid
        size={{
          lg: 4,
          sm: 4,
          xs: 12,
        }}
      >
        <BoxStyled
          onClick={() => setFilter('total_tickets')}
          sx={{ backgroundColor: 'primary.light', color: 'primary.main' }}
        >
          <Typography variant="h3">{meta?.total || 0}</Typography>
          <Typography variant="h6">{t('tickets.filter.totalTickets')}</Typography>
        </BoxStyled>
      </Grid>
      <Grid
        size={{
          lg: 4,
          sm: 4,
          xs: 12,
        }}
      >
        <BoxStyled
          onClick={() => setFilter('Open')}
          sx={{ backgroundColor: 'secondary.light', color: 'secondary.main' }}
        >
          <Typography variant="h3">{meta?.opened || 0}</Typography>
          <Typography variant="h6">{t('tickets.filter.openTickets')}</Typography>
        </BoxStyled>
      </Grid>
      <Grid
        size={{
          lg: 4,
          sm: 4,
          xs: 12,
        }}
      >
        <BoxStyled
          onClick={() => setFilter('Closed')}
          sx={{ backgroundColor: 'error.light', color: 'error.main' }}
        >
          <Typography variant="h3">{meta?.closed || 0}</Typography>
          <Typography variant="h6">{t('tickets.filter.closedTickets')}</Typography>
        </BoxStyled>
      </Grid>
    </Grid>
  );
};

export default TicketFilter;
